import {VariantStateKey} from '@packages/systems/style-legacy/selectors';
import {BREAKPOINT_ID_MAIN} from '@packages/systems/style/breakpoint-ids';
import {BreakpointID} from '@packages/systems/style/types';

/**
 * Helper function determining when Layout Row editing should be locked.
 *
 * Return `true` if either the provided `mediaQuery` is not the main breakpoint,
 * or if there is a non-null `variantState` which denotes that the Layout is being
 * edited inside of a Component style variant.
 */
const isRowEditingLocked = (
  mediaQuery: BreakpointID,
  variantState: VariantStateKey | null
) => mediaQuery !== BREAKPOINT_ID_MAIN || variantState != null;

export default isRowEditingLocked;
